
function calculate_price() {

  console.log('Hello I am Calculate Price');
  const foamType = $(document).find('.product-variant-container.cus_Foam option:selected').val();
  const unit = $(document).find('.product-variant-container.cus_unit option:selected').val();
  const options = $(document).find('.product-variant-container.cus_Options option:selected').val();


  const height = parseFloat($(document).find('#cus_height').val());
  const width = parseFloat($(document).find('#cus_width').val());
  const depth = parseFloat($(document).find('#cus_depth').val());   
  const qty = parseFloat($(document).find('[name="quantity"]').val());  

  let volume = 0;
  const foamPriceMultiplier = FOAM_PRICE_MULTIPLIERS[foamType] || 0;
  const optionMultiplier = OPTION_MULTIPLIERS[options] || 1;
  let totalPrice = 0;

  if(isNaN(height) || isNaN(width) || isNaN(depth) ) {
    $("#dataprice").html('<strong>£ 3.00</strong>'); 
    return 0;
  }
  if (height <= 0 || width <= 0 || depth <= 0) {
        $("#dataprice").html('<strong>£ 3.00</strong>');
    return 0;
  }

  switch (unit) {
      case 'cm':
          volume = height * width * depth / 2360;
          break;
      case 'mm':
          volume = height * width * depth / 2360000;
          break;
      case 'in':
          volume = height * width * depth / 144;
          break;
      default:
          $("#dataprice").html('<strong>£ 3.00</strong>');
      return 0;
  }

  if (foamPriceMultiplier === 0) {
      $("#dataprice").html('<strong>£ 3.00</strong>');
      return 0;
  }

  totalPrice = (volume * foamPriceMultiplier) * optionMultiplier;
  totalPrice += 3; // Add additional cost

  $("#dataprice").html('<strong>£ '+totalPrice.toFixed(2)+'</strong>');
    return totalPrice.toFixed(2);
} 
 
 $(document).ready(function(){          
          
  $(document).find('.custom-description').hide();
  var this_v = $(document).find('.product-variant-container.cus_Foam option:selected').val();
      
    if (this_v == 'Memory Foam') {
      $(document).find('.custom-description.Memory_Foam').show();
    } else if (this_v == 'Packaging Foam') {
      $(document).find('.custom-description.Packaging_Foam').show();
    }else  if (this_v == 'Luxury GOLD SOFT Foam') {
        $(document).find('.custom-description.luxury_gold_sft_foam').show();
    }else  if (this_v == 'Soft Foam') {
        $(document).find('.custom-description.Soft_Foam').show();
    }else  if (this_v == 'Medium Soft Foam') {
        $(document).find('.custom-description.Medium_Soft_Foam').show();
    } else  if (this_v == 'Medium Foam') {
      $(document).find('.custom-description.Medium_Foam').show();
    } else  if (this_v == 'Firm Foam') {
      $(document).find('.custom-description.Firm_Foam').show();
    } else  if (this_v == 'Extra Firm / Chip / Reconstituted Foam') {
      $(document).find('.custom-description.Extra_Firm_Chip_Reconstituted').show();
    }

    $(document).on('change','.product-variant-container.cus_Foam',function(){
      var this_v = $(this).val();
      $(document).find('.custom-description').hide();
      if (this_v == 'Memory Foam') {
        $(document).find('.custom-description.Memory_Foam').show();
      } else if (this_v == 'Packaging Foam') {
        $(document).find('.custom-description.Packaging_Foam').show();
      } else  if (this_v == 'Luxury GOLD SOFT Foam') {
          $(document).find('.custom-description.luxury_gold_sft_foam').show();
      } else  if (this_v == 'Soft Foam') {
          $(document).find('.custom-description.Soft_Foam').show();
      }else  if (this_v == 'Medium Soft Foam') {
          $(document).find('.custom-description.Medium_Soft_Foam').show();
      } else  if (this_v == 'Medium Foam') {
        $(document).find('.custom-description.Medium_Foam').show();
      } else  if (this_v == 'Firm Foam') {
        $(document).find('.custom-description.Firm_Foam').show();
      } else  if (this_v == 'Extra Firm / Chip / Reconstituted Foam') {
        $(document).find('.custom-description.Extra_Firm_Chip_Reconstituted').show();
      }
    });  


    $(document).find('.option-value').hide();
    var this_v = $(document).find('.product-variant-container.cus_Options option:selected').val();
    console.log(this_v);
    if (this_v == 'Just Foam') {
      $(document).find('.option-value.Just_Foam').show();
    } else if (this_v == 'Stockinette') {
      $(document).find('.option-value.Stockinette').show();
    } else if (this_v == 'Fibre') {
        $(document).find('.option-value.Fibre').show();
    } else  if (this_v == 'Stockinette & Fibre') {
      $(document).find('.option-value.Stockinette_Fibre').show();
    }

    $(document).on('change','.product-variant-container.cus_Options',function(){
      var this_v = $(this).val();
      $(document).find('.option-value').hide();
      console.log(this_v);
      if (this_v == 'Just Foam') {
        $(document).find('.option-value.Just_Foam').show();
      } else if (this_v == 'Stockinette') {
        $(document).find('.option-value.Stockinette').show();
      } else  if (this_v == 'Fibre') {
          $(document).find('.option-value.Fibre').show();
      } else  if (this_v == 'Stockinette & Fibre') {
        $(document).find('.option-value.Stockinette_Fibre').show();
      }
    });


    $(document).on('change','.product-variant-container.cus_unit',function(){
      var this_v = $(this).val();
      console.log(this_v);
      if (this_v == 'cm') {
        $(document).find('#unit_price').attr('unit-attr','2360');
      } else if (this_v == 'in') {
        $(document).find('#unit_price').attr('unit-attr','144');
      } else  if (this_v == 'mm') {
        $(document).find('#unit_price').attr('unit-attr','2360000');
      }
    });

    $('.lodder_overlay').hide();
      
    $(document).on('click','.add-to-cart',function(no_reload){
        
    var height = $(document).find('#cus_height').val();
    var width = $(document).find('#cus_width').val();
    var depth = $(document).find('#cus_depth').val();   
    var cusExtraA = $(document).find('#height_curve').val(); 
    
    if (height.length > 0 && width.length > 0 && depth.length > 0 && cusExtraA.length > 0) {
        no_reload.preventDefault();
    } else {
      return;
    }
    var this_Foam = $(document).find('.product-variant-container.cus_Foam option:selected').val();
    var this_unit = $(document).find('.product-variant-container.cus_unit option:selected').val();
    var this_Options = $(document).find('.product-variant-container.cus_Options option:selected').val();
    var qty = $(document).find('[name="quantity"]').val(); 
    var heightcurve = $(document).find('#height_curve').val();  
    var price = calculate_price();
    if (price <= 0) {
      return;
    }
    $(this).prop('disabled', true);
    $(this).find('span.button__text').html('Adding cart ....');

    var data = {
      foamType: this_Foam,
      unit: this_unit,
      options: this_Options,
      height: height,
      width: width,
      depth: depth,
      cusExtraA:cusExtraA,
      operation: 'manage-product',
      productType : 'Chair Cushion',
      price : price
    };
           
    $.ajax({
        type: 'POST',
        url: 'https://faas-lon1-917a94a7.doserverless.co/api/v1/web/fn-4ee39a0e-3a23-405c-94fb-ad473eda4e1d/default/product-calculator',
        data: data,
        success: function(result) {
        console.log(result);
          if(result.status) {
            var data = {
                "id": result.id,
                "quantity": qty,
                "properties": { 
                'Foam':this_Foam,
                'Unit':this_unit,
                'Options':this_Options,
                'Height (a)' : height,
                'Width (b)' : width,
                'Depth (c)' : depth,
                'Height to Curve (d)':heightcurve                     
              }
            }
                   
            jQuery.ajax({
              type: 'POST',
              url: '/cart/add.js',
              data: data,
              dataType: 'json',
              success: function() {
                localStorage.setItem("reload_value", "fire");
                setTimeout(function() {
                    location.href = '/cart';
                },500);
              }
          });
        }
      }
    });
       
    
  });
  $("#cus_height, #cus_width,#cus_depth").on("keyup", function(){   
      calculate_price();
    });             
    
    $(document).on('change','.product-variant-container.cus_Foam,.product-variant-container.cus_Options,.product-variant-container.cus_unit',function(){
          calculate_price();
    });

});
